var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-with-reset"},[_c('input',{attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":(event) => _vm.$emit('input', event.target.value)}}),_c('button',{on:{"click":() => _vm.$emit('reset')}},[(_vm.icon === 'revert')?_c('RevertIcon',{attrs:{"size":_vm.iconSize}}):_c('CloseIcon',{attrs:{"size":_vm.iconSize}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }